export const convertProductPropertiesFormIntoArray = (currentProductProperties) => {
  const propertiesArray = []
  const { formData, JSONSchema: { definitions } } = currentProductProperties
  const propertiesNames = Object.keys(formData)

  for (const name of propertiesNames) {
    const propertyDefinition = definitions[name]
    if (formData[name]) {
      propertiesArray.push({ id: propertyDefinition.custom.id, value: formData[name] })
    }
  }

  return propertiesArray.map((p) => ({ ...p }))
}
